"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purgeQueryParameters = exports.oauthParamsToOmit = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
const oauthParamsToOmit = exports.oauthParamsToOmit = ["oauth-login", "auth_token", "oneTap", "origin", "user_id", "error_code", "message"];
const purgeQueryParameters = (queryParams, queryParamsToOmit) => {
  const purgedQuery = Object.fromEntries(Object.entries(queryParams).filter(_ref => {
    let [key] = _ref;
    return !queryParamsToOmit.includes(key);
  }));
  const query = _queryString.default.stringify(purgedQuery);
  return query.length === 0 ? "" : `?${query}`;
};
exports.purgeQueryParameters = purgeQueryParameters;